import React from 'react';
import PropTypes from 'prop-types';
import Button from 'base-ui/dist/Button';
import Icon from 'base-ui/dist/Icon';
import { FacebookLogin as FBLogin } from 'react-auth';
import getConfig from 'next/config';

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const facebookAppId = publicRuntimeConfig ? (publicRuntimeConfig.fb_app_id || publicRuntimeConfig.FACEBOOK_APP_ID) : process.env.FACEBOOK_APP_ID;

/**
 * FacebookLogin.js
 *
 * Render a button to connect facebook provider using react-auth.
 */
const FacebookLogin = ({ action, label }) => (
  <FBLogin
    clientId={facebookAppId}
    scope={'public_profile, email'}
    responseType="code"
    onCode={action}
    redirectUri={`${window.location.origin}/`}
  >
    <Button
      className="full"
      size="big"
      color="facebook"
      borderColor="facebook"
      textColor="white"
      tag="a"
    >
      <Icon name="facebook" prefix="fab" />
      {' '}
      {label}
    </Button>
  </FBLogin>
);

FacebookLogin.propTypes = {
  /**
   * The callback action that perform when we receive authorization code from provider.
   */
  action: PropTypes.func.isRequired,
  /**
   * A simple label to show on button.
   */
  label: PropTypes.string.isRequired,
};

export default FacebookLogin;
